import { render, staticRenderFns } from "./editarVentana.vue?vue&type=template&id=88067d80&scoped=true"
import script from "./editarVentana.vue?vue&type=script&lang=js"
export * from "./editarVentana.vue?vue&type=script&lang=js"
import style0 from "./editarVentana.vue?vue&type=style&index=0&id=88067d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88067d80",
  null
  
)

export default component.exports